import type { AuthFrame } from '@platform/app-kit';

/** This app's product (products/mymedmetrics/product.yaml): what it asks the platform for. */
export const PRODUCT = 'mymedmetrics';

/** The product's name as people see it (product.yaml `displayName`). */
export const PRODUCT_NAME = 'MyMedMetrics';

/**
 * The pre-auth frame copy. The look is the design system's default theme until the product gets
 * its own brand (#26).
 */
export const AUTH_FRAME: AuthFrame = {
  brandName: PRODUCT_NAME,
  pitch: 'Your health numbers, in one place.',
  supporting: 'A private home for the readings that matter to you.',
};
